export default [{"url":"https://lobi-0.api.invexerp.io","name":"Branch 1","port":"6533","isStore":true,"isHQ":true}]